import { EDrawingActionType, TMapActions, ERulerActionType } from '../../actions';

export const defaultState = false;

export function isDrawingModeReducer(state: boolean = defaultState, action: TMapActions): boolean {
  switch (action.type) {
    case EDrawingActionType.DrawingStarted:
      return true;
    case EDrawingActionType.DrawingFinished:
    case ERulerActionType.RulerEnabled:
      return false;
    default:
      return state;
  }
}
